<template>
  <div>
    <search-nav @handleSearch="handleSearch">
      <search-nav-item-select label="검색조건" v-model="searchType" :list="searchTypes" />
      <search-nav-item-field label="" v-model="keyword" @keyupEvent="handleInput" />
    </search-nav>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNavItemField from "@/components/nav/SearchNavItemField.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";

export default {
  components: {SearchNavItemSelect, SearchNavItemField, SearchNavYearMonth, SearchNav},
  data () {
    return {
      keyword: '',
      searchType: '',
      searchTypes: [
        { text: "학교(기관) 구분", value: "cat3Name" },
        { text: "학교(기관)명", value: "field_name" },
        { text: "학교(기관)장", value: "director_name" },
        { text: "관리감독자", value: "행정실장" },
        { text: "학교(기관) 담당자", value: "학교담당자" },
        { text: "안전점검기관", value: "companyNames" },
      ],
    }
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    fieldId () {
      return this.$route.params.fieldId
    },
  },
  methods: {
    // 사업장 검색 폼에서 Enter 키가 눌렸을 때
    handleInput(data) {
      this.keyword = data;
      this.handleSearch();
    },
    // "검색" 버튼이 클릭됐을 때
    handleSearch() {
      this.$emit("search", {
        keyword: this.keyword,
        searchType: this.searchType
      })
    },
  }
}
</script>

<style scoped>

</style>
